import React from "react";
import Modal from "@/components/Modal";
import ImportGroupContent from "./Import";
import { useTranslation } from "@/langs/useTranslation";

function ImportGroupDialog({ title="汇入子门店",open, groupId, onSuccess, onClose }) {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        title={title}
        width={500}
        open={open}
        onClose={onClose}
        footer={null}
      >
        <ImportGroupContent
          groupId={groupId}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </Modal>
    </>
  );
}

export default ImportGroupDialog;
